import React, { Component, Fragment } from 'react'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { contentActions, messageActions } from '../../../actions'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import FileUpload from 'material-ui/svg-icons/file/file-upload'
import SelectWrapped from '../../../components/SelectWrapped'
import { formatContentSelectValue, filterOptionsFunction } from '../../../utils'
import * as API from '../../../api'
import Typography from '@material-ui/core/Typography'
import { IsbnField, EdicaoField, CopyrightField } from '../../../components/Fields'
import { readOnly } from '../../../utils/permissions'
import EditIcon from 'material-ui/svg-icons/image/edit'
import EditDocumentModal from '../EditDocumentModal'

const styles = theme => ({
  layout: {
    height: 'calc(100% - 64px)',
    position: 'relative'
  },
  contentForm: {
    background: '#fff',
    height: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing.unit * 3,
    overflow: 'auto'
  },
  formGroup: {
    padding: '12px 0'
  },
  formControl: {
    margin: '12px 0'
  },
  uploadButton: {
    margin: '15px 0',
    padding: '0 16px',
    background: 'rgb(0, 45, 114)',
    color: '#fff'
  },
  uploadButtonIcon: {
    color: 'inherit !important',
    marginLeft: '3px'
  },
  editButton: {
    margin: '15px 0',
    marginLeft: '10px',
    padding: '0 16px',
    background: 'rgb(0, 45, 114)',
    color: '#fff'
  },
  uploadButtonIcon: {
    color: 'inherit !important',
    marginLeft: '3px'
  }
})

class Medicamento extends Component {
  handleChangeFile = e => {
    e.preventDefault()
    const { handleChangeContent, content, getHtmlPreview, changeMessage } = this.props

    let [file] = e.target.files

    if (file) {
      handleChangeContent({
        ...content,
        document: file || ''
      })
      getHtmlPreview({ document: file })
        .then(() => {
          changeMessage({ message: 'Pré-visualização carregada com sucesso.' })
        })
        .catch(error => {
          const { response = {} } = error

          if (response.status === 400) {
            return changeMessage({ message: 'Formato de arquivo inválido.' })
          }

          return changeMessage({
            message: 'Não foi possível carregar a pré-visualização. Tente novamente mais tarde.'
          })
        })
    } else {
      handleChangeContent({
        ...content,
        document: file || ''
      })
    }
  }
  componentDidMount() {
    this.props.removeHtmlDocument()
  }
  render() {
    const {
      classes,
      content,
      handleChangeContent,
      handleChangeReference,
      contentFormErrors,
      formTouched,
      removeHtmlDocument,
      token,
      openEditDocumentModal
    } = this.props
    const { handleChangeFile } = this

    const isReadOnly = readOnly(content.tipo, token)

    return (
      <Fragment>
        <div>
          <input type="file" id="upload" style={{ display: 'none' }} onChange={handleChangeFile} />
          {!!content.document && (
            <Button
              small
              onClick={() => {
                removeHtmlDocument()
              }}
              color={'secondary'}
              disabled={isReadOnly}
            >
              Remover
            </Button>
          )}
          <Button
            htmlFor="upload"
            component={'label'}
            variant="raised"
            color={'primary'}
            className={classes.uploadButton}
            disabled={isReadOnly}
          >
            Upload HTML <FileUpload className={classes.uploadButtonIcon} />
          </Button>
          <Button
            onClick={() => openEditDocumentModal()}
            component={'label'}
            variant="raised"
            color={'primary'}
            className={classes.editButton}
            disabled={isReadOnly}
          >
            Editar <EditIcon className={classes.uploadButtonIcon} />
          </Button>
          {!((contentFormErrors.fields || {})['document'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['document'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <div className={classes.formControl}>
          <FormControl
            error={!((contentFormErrors.fields || {})['principioAtivo'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-principioAtivo">Princípio ativo</InputLabel>
            <Input
              disabled={isReadOnly}
              fullWidth
              required={'required'}
              type="text"
              onChange={e => {
                handleChangeContent({ ...content, principioAtivo: e.target.value })
              }}
              value={content.principioAtivo}
              id="field-principioAtivo"
            />
            {!((contentFormErrors.fields || {})['principioAtivo'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['principioAtivo'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
        </div>
        <TextField
          disabled={isReadOnly}
          fullWidth
          onChange={obj => {
            handleChangeContent({ ...content, autores: obj })
          }}
          error={!((contentFormErrors.fields || {})['autores'] || {}).valid && formTouched}
          value={formatContentSelectValue(content.autores || [])}
          placeholder="Selecione..."
          name="react-select-chip-autores"
          label="Autores"
          InputLabelProps={{
            shrink: true
          }}
          InputProps={{
            inputComponent: SelectWrapped,
            inputProps: {
              multi: true,
              filterOptions: filterOptionsFunction,
              instanceId: 'react-select-chip-label',
              id: 'react-select-chip-autores',
              loadOptions: API.authors.getSelectAuthors,
              disableDelete: isReadOnly
            }
          }}
        />
        {!((contentFormErrors.fields || {})['autores'] || {}).valid && formTouched ? (
          <Typography className={classes.errorMessage} noWrap color={'error'}>
            {((contentFormErrors.fields || {})['autores'] || {}).errorMessage}
          </Typography>
        ) : null}
        <FormControl
          error={
            !((contentFormErrors.fields || {})['classificacaoTerapeutica'] || {}).valid &&
            formTouched
          }
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-classificacaoTerapeutica">
            Classificação terapêutica
          </InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, classificacaoTerapeutica: e.target.value })
            }}
            value={content.classificacaoTerapeutica}
            id="field-classificacaoTerapeutica"
          />
          {!((contentFormErrors.fields || {})['classificacaoTerapeutica'] || {}).valid &&
          formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['classificacaoTerapeutica'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <div className={classes.formControl}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            onChange={obj => {
              handleChangeContent({ ...content, palavrasChave: obj })
            }}
            value={formatContentSelectValue(content.palavrasChave || [])}
            placeholder="Selecione..."
            name="react-select-chip-keywords"
            label="Palavras-chave"
            error={!((contentFormErrors.fields || {})['palavrasChave'] || {}).valid && formTouched}
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-keywords',
                loadOptions: API.keywords.getSelectKeywords,
                disableDelete: isReadOnly
              }
            }}
          />
          {!((contentFormErrors.fields || {})['palavrasChave'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['palavrasChave'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <FormControl
          error={!((contentFormErrors.fields || {})['pesoDA'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-pesoDA">Peso DA</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="number"
            onChange={e => {
              handleChangeContent({ ...content, pesoDA: e.target.value })
            }}
            value={content.pesoDA}
            id="field-pesoDA"
          />
          {!((contentFormErrors.fields || {})['pesoDA'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['pesoDA'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          error={!((contentFormErrors.fields || {})['idioma'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-idioma">Idioma</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, idioma: e.target.value })
            }}
            value={content.idioma}
            id="field-idioma"
          />
          {!((contentFormErrors.fields || {})['idioma'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['idioma'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <fieldset>
          <legend>Livro</legend>
          <div className={classes.formControl}>
            <TextField
              disabled={isReadOnly}
              fullWidth
              className={classes.formControl}
              onChange={livroReferencia => {
                handleChangeReference('livro', livroReferencia)
              }}
              error={
                !((contentFormErrors.fields || {})['livroReferencia'] || {}).valid && formTouched
              }
              value={content.livroReferencia}
              placeholder="Selecione..."
              name="react-select-chip-preCadastro"
              label="Pré-cadastro"
              InputLabelProps={{
                shrink: true
              }}
              InputProps={{
                inputComponent: SelectWrapped,
                inputProps: {
                  multi: false,
                  filterOptions: filterOptionsFunction,
                  instanceId: 'react-select-chip-label',
                  id: 'react-select-chip-preCadastro',
                  options: [],
                  loadOptions: API.preRegistrations.getSelectPreRegistrations('livro')
                }
              }}
            />
            {!((contentFormErrors.fields || {})['livroReferencia'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['livroReferencia'] || {}).errorMessage}
              </Typography>
            ) : null}
          </div>
          <FormControl
            error={!((contentFormErrors.fields || {})['tituloLivro'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-tituloLivro">Título livro</InputLabel>
            <Input
              disabled={!!content.livroReferencia || isReadOnly}
              fullWidth
              required={'required'}
              type="text"
              onChange={e => {
                handleChangeContent({ ...content, tituloLivro: e.target.value })
              }}
              value={content.tituloLivro}
              id="field-tituloLivro"
            />
            {!((contentFormErrors.fields || {})['tituloLivro'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['tituloLivro'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
          <div className={classes.formControl}>
            <TextField
              disabled={!!content.livroReferencia || isReadOnly}
              fullWidth
              className={classes.formControl}
              onChange={obj => {
                handleChangeContent({ ...content, autoresLivro: obj })
              }}
              value={formatContentSelectValue(content.autoresLivro || [])}
              placeholder="Selecione..."
              name="react-select-chip-autoresLivro"
              label="Autores livro"
              InputLabelProps={{
                shrink: true
              }}
              InputProps={{
                inputComponent: SelectWrapped,
                inputProps: {
                  multi: true,
                  filterOptions: filterOptionsFunction,
                  instanceId: 'react-select-chip-label',
                  id: 'react-select-chip-autoresLivro',
                  loadOptions: API.authors.getSelectAuthors,
                  disableDelete: !!content.livroReferencia || isReadOnly
                }
              }}
            />
            {!((contentFormErrors.fields || {})['autoresLivro'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['autoresLivro'] || {}).errorMessage}
              </Typography>
            ) : null}
          </div>
          <FormControl
            error={!((contentFormErrors.fields || {})['isbn'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-isbn">ISBN</InputLabel>
            <Input
              disabled={!!content.livroReferencia || isReadOnly}
              fullWidth
              inputComponent={IsbnField}
              required={'required'}
              type="text"
              onChange={e => {
                handleChangeContent({ ...content, isbn: e.target.value })
              }}
              value={content.isbn || ''}
              id="field-isbn"
            />
            {!((contentFormErrors.fields || {})['isbn'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['isbn'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
          <FormControl
            error={!((contentFormErrors.fields || {})['codigoProtheus'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-codigoProtheus">Código Protheus</InputLabel>
            <Input
              disabled={!!content.livroReferencia || isReadOnly}
              fullWidth
              required={'required'}
              type="text"
              inputComponent={IsbnField}
              onChange={e => {
                handleChangeContent({ ...content, codigoProtheus: e.target.value })
              }}
              value={content.codigoProtheus || ''}
              id="field-codigoProtheus"
            />
            {!((contentFormErrors.fields || {})['codigoProtheus'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['codigoProtheus'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
          <FormControl
            error={!((contentFormErrors.fields || {})['copyrightLivro'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-copyrightLivro">Ano copyright</InputLabel>
            <Input
              disabled={!!content.livroReferencia || isReadOnly}
              fullWidth
              required={'required'}
              inputComponent={CopyrightField}
              onChange={e => {
                handleChangeContent({ ...content, copyrightLivro: e.target.value })
              }}
              value={content.copyrightLivro || ''}
              id="field-copyrightLivro"
            />
            {!((contentFormErrors.fields || {})['copyrightLivro'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['copyrightLivro'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
          <FormControl
            error={!((contentFormErrors.fields || {})['edicaoLivro'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-edicaoLivro">Edição</InputLabel>
            <Input
              disabled={!!content.livroReferencia || isReadOnly}
              fullWidth
              required={'required'}
              type="text"
              inputComponent={EdicaoField}
              onChange={e => {
                handleChangeContent({ ...content, edicaoLivro: e.target.value })
              }}
              value={content.edicaoLivro || ''}
              id="field-edicaoLivro"
            />
            {!((contentFormErrors.fields || {})['edicaoLivro'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['edicaoLivro'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
          <TextField
            disabled={!!content.livroReferencia || isReadOnly}
            fullWidth
            className={classes.formControl}
            onChange={obj => {
              handleChangeContent({ ...content, especialidadesLivro: obj })
            }}
            value={formatContentSelectValue(content.especialidadesLivro || [])}
            placeholder="Selecione..."
            name="react-select-chip-especialidadesLivro"
            label="Especialidades livro"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-especialidadesLivro',
                loadOptions: API.specialities.getSelectSpecialities,
                disableDelete: !!content.livroReferencia || isReadOnly
              }
            }}
          />
        </fieldset>
        <fieldset>
          <legend>Seção</legend>
          <FormControl
            error={!((contentFormErrors.fields || {})['tituloSecao'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-tituloSecao">Título seção</InputLabel>
            <Input
              disabled={isReadOnly}
              fullWidth
              type="text"
              onChange={e => {
                handleChangeContent({ ...content, tituloSecao: e.target.value })
              }}
              value={content.tituloSecao}
              id="field-tituloSecao"
            />
            {!((contentFormErrors.fields || {})['tituloSecao'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['tituloSecao'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
          <TextField
            disabled={isReadOnly}
            fullWidth
            className={classes.formControl}
            onChange={obj => {
              handleChangeContent({ ...content, autoresSecao: obj })
            }}
            value={formatContentSelectValue(content.autoresSecao || [])}
            placeholder="Selecione..."
            name="react-select-chip-autoresSecao"
            label="Autores seção"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-autoresSecao',
                loadOptions: API.authors.getSelectAuthors,
                disableDelete: isReadOnly
              }
            }}
          />
          <FormControl
            error={!((contentFormErrors.fields || {})['textoSecao'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-textoSecao">Sobre a seção</InputLabel>
            <Input
              disabled={isReadOnly}
              fullWidth
              type="text"
              onChange={e => {
                handleChangeContent({ ...content, textoSecao: e.target.value })
              }}
              value={content.textoSecao}
              id="field-textoSecao"
            />
            {!((contentFormErrors.fields || {})['textoSecao'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['textoSecao'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
        </fieldset>
        <EditDocumentModal content={content} handleChangeContent={handleChangeContent} />
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    content: state.content.content,
    contentFormErrors: state.content.contentFormErrors,
    formTouched: state.content.contentFormTouched,
    conteudoHtml: state.content.conteudoHtml,
    token: state.auth.token
  }
}
const mapDispatchToProps = dispatch => {
  return {
    handleChangeContent: content => {
      dispatch(contentActions.handleChangeContent(content))
    },
    handleChangeReference: (refType, reference) => {
      dispatch(contentActions.handleChangeReference({ refType, reference }))
    },
    setContentFormTouched: () => {
      return dispatch(contentActions.setContentFormTouched())
    },
    getHtmlPreview: content => {
      return dispatch(contentActions.getHtmlPreview(content))
    },
    changeMessage: ({ message, anchorOrigin }) => {
      dispatch(messageActions.changeMessage({ message, anchorOrigin }))
    },
    removeHtmlDocument: () => {
      return dispatch(contentActions.removeHtmlDocument())
    },
    openEditDocumentModal: () => {
      dispatch(contentActions.openEditDocumentModal())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(Medicamento))



// WEBPACK FOOTER //
// ./src/containers/Content/ContentTypes/Medicamento.js